import { render, staticRenderFns } from "./List-Call-Centers.vue?vue&type=template&id=32e355ee"
import script from "./List-Call-Centers.vue?vue&type=script&lang=js"
export * from "./List-Call-Centers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports